import { ThemeOptionsWithDefault } from './types';

export function getByThemeOrDefault<T>(obj: ThemeOptionsWithDefault<T>, key: keyof ThemeOptionsWithDefault<T>) {
    return obj[key] ?? obj.default;
}
